import React from 'react'
// import { Container } from 'react-bootstrap';

import img1 from '../assets/img_1.jpg';



const Products = () => {
    return (

        <div id="products" className='outer-page-content-container'>


            <h2 className='abt-title'>Our Gallary</h2>
            <div className="gallery">
                <div className="image-container">
                    <img src={img1}  alt='#'/>
                </div>
                <div className="image-container">
                    <img src="2.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="3.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="4.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="5.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="6.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="7.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="8.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="9.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="10.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="11.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="12.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="13.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="14.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="15.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="16.jpg" alt='#'/>
                </div>
                <div className="grid-item">
                    <img src="17.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="18.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="19.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="20.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="21.jpg" alt='#'/>
                </div>
                <div className="image-container tall">
                    <img src="22.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="23.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="24.jpg" alt='#'/>
                </div>
                <div className="image-container">
                    <img src="25.jpg" alt='#'/>
                </div>
            </div>

            






        </div>

    )
}

export default Products